import {Injectable} from '@angular/core';
import {ContractLink, ContractLinkForm} from '../models/contract-link';
import {CommonField} from '../models/common-field';

@Injectable({
  providedIn: 'root'
})
export class LinkContractMapperService {

  constructor() {}

  formToDb(form: ContractLinkForm , subList: CommonField[]): ContractLink {
    return {
      'startBilling': form.startBilling,
      'endBilling': form.endBilling,
      'companies': {
      'id': 0,
      'uuid': form.companyUuid,
      'name': form.companyName,
      'displayName': form.companyName
    },
      'isActualCompanyLink': form.isActualCompanyLink,
      'subscriptions': subList,
      'contracts':  {
      'id': 0,
      'uuid': form.contractUuid,
      'name': form.contractName,
      'displayName': form.contractName
    },
    }
  }
}

